export default __webpack_public_path__ + "static/media/saee.079e9dda.svg";